import React from 'react';

import CustomTooltip from '../../../../../common-components/CustomTooltip/CustomTooltip';

import './LabelGroup.scss';

import { shortString } from '@/utils/global';

interface Label {
  _id: string;
  color: string;
  title: string;
}

interface LabelGroupProps {
  labels: Label[];
  showAllLabels?: boolean;
}

const LabelGroup: React.FC<LabelGroupProps> = ({ labels, showAllLabels = false }) => {
  const visibleLabels = showAllLabels ? labels : labels.slice(0, 2);
  const remainingCount = Math.max(0, labels.length - 2);
  const hasMoreLabels = showAllLabels ? false : remainingCount > 0;

  const renderLabel = (label: Label) => (
    <span key={label._id} className="label-group__label" style={{ backgroundColor: label.color }}>
      {showAllLabels ? label.title : shortString(label.title, 10)}
    </span>
  );

  const tooltipContent = (
    <div className="label-group__tooltip-content">
      {labels.map((label) => (
        <div key={label._id} className="label-group__tooltip-content-item">
          <span className="label-group__tooltip-content-item-color" style={{ backgroundColor: label.color }} />
          <span className="label-group__tooltip-content-item-title">{label.title}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div className="label-group">
      <CustomTooltip title={tooltipContent} placement="bottom" show={!showAllLabels}>
        <div className="label-group__container">
          {visibleLabels.map(renderLabel)}
          {hasMoreLabels && <span className="label-group__remaining">+{remainingCount}</span>}
        </div>
      </CustomTooltip>
    </div>
  );
};

export default LabelGroup;
